import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import DoubleCounter from 'components/shared/counters/double/DoubleCounter';
import Emoji from 'components/shared/Emoji';
import routes from 'common/routes';

function ClientPaymentCounter() {
  const { t } = useTranslation(['labels']);
  const navigate = useNavigate();

  const currentMonthIncomeInCop = useSelector(
    (state) => state.clientPayment.counters.currentMonthIncomeInCop
  );
  const currentMonthIncomeInUsd = useSelector(
    (state) => state.clientPayment.counters.currentMonthIncomeInUsd
  );

  return (
    <DoubleCounter
      emoji={<Emoji label={t('monthlyIncome', { ns: 'labels' })} symbol="💳" />}
      title={t('monthlyIncomes', { ns: 'labels' })}
      type="currency"
      onClick={() => navigate(routes.payments.path)}
      counters={[
        {
          title: t('cop', { ns: 'common' }),
          counter: currentMonthIncomeInCop
        },
        {
          title: t('usd', { ns: 'common' }),
          counter: currentMonthIncomeInUsd
        }
      ]}
    />
  );
}

export default ClientPaymentCounter;
